import React, { Component } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

export interface ColorItemSliderProps
{
    onColorChanged: (colorHex: string) => void;
}

interface ColorItemSliderState 
{
    colors: Array<JSX.Element>;
}

export interface ColorItem 
{
    name: string;
    colorHex: string;
}

export class ColourItemSlider extends Component<ColorItemSliderProps, ColorItemSliderState>
{
    private swiper: any = null;

    private colors: Array<ColorItem> = [
        {
            name: "Yellow",
            colorHex: "#f4e487",
        },
        {
            name: "Yellow",
            colorHex: "#fdef2f"
        },
        {
            name: "Yellow",
            colorHex: "#ffcd00",
        },
        {
            name: "Orange",
            colorHex: "#ff8c2b",
        },

        {
            name: "Dark Orange",
            colorHex: "#de341d",
        },
        {
            name: "Red",
            colorHex: "#f40000",
        },

        {
            name: "Pink",
            colorHex: "#da007e",
        },
        {
            name: "Pink",
            colorHex: "#df2b7d"
        },
        {
            name: "Purple",
            colorHex: "#706ab0"
        },
        {
            name: "Light Pink",
            colorHex: "#f8cde2",
        },
        {
            name: "Pink",
            colorHex: "#c0a6e3",
        },
        {
            name: "Teal",
            colorHex: "#35c2e0",
        },
        {
            name: "Light blue",
            colorHex: "#007fe1",
        },
        {
            name: "Dark blue",
            colorHex: "#0047ba",
        },
        {
            name: "Dark green",
            colorHex: "#1c6638",
        },
        {
            name: "Light green",
            colorHex: "#99c227",
        },
        {
            name: "Green",
            colorHex: "#b7d69b",
        },
        {
            name: "Maroon",
            colorHex: "#810036",
        },
        {
            name: "Maroon",
            colorHex: "#e32478",
        },
        {
            name: "Grey",
            colorHex: "#d8d8d8"
        },
        {
            name: "White",
            colorHex: "#fff"
        },
        {
            name: "Brown",
            colorHex: "#e98900"
        },

        {
            name: "Light brown",
            colorHex: "#f5af2a",
        },
        {
            name: "Brown",
            colorHex: "#7e5d36"
        },
        {
            name: "Brown",
            colorHex: "#b77e40"
        },
        {
            name: "Light brown",
            colorHex: "#a69f87"
        },
    ];

    private selected: ColorItem = this.colors[3];

    constructor(props: ColorItemSliderProps)
    {
        super(props);

        this.state = {
            colors: null
        };
    }

    public componentDidMount(): void
    {
        if (this.selected)
        {
            this.props.onColorChanged(this.selected.colorHex);
        }

        this.setState({
            colors: this.buildColours()
        });
    }

    private buildColours(): Array<JSX.Element>
    {
        let items = [];

        for (let i = 0; i < this.colors.length; i++)
        {
            let item: ColorItem = this.colors[i];
            let selected: boolean = this.selected.colorHex === item.colorHex;
            items.push(
                <SwiperSlide key={"key_" + item.colorHex}>
                    <button
                        className={`btn colour ${selected === true ? "active" : ""}`}
                        style={{ backgroundColor: item.colorHex }}
                        title={item.name}
                        onClick={this.onClick.bind(this, item, i)}>
                    </button>
                </SwiperSlide>
            );
        }

        return items;
    }

    private onClick(colorItem: ColorItem, index: number): void 
    {
        // this.swiper.slideTo(index);
        this.props.onColorChanged(colorItem.colorHex);
        this.selected = colorItem;
        this.setState({
            colors: this.buildColours()
        });
    }

    public render(): JSX.Element
    {
        return (
            <>
                <Swiper
                    spaceBetween={3}
                    slidesPerView={6.5}
                    onSwiper={(swiper) => this.swiper = swiper}
                >
                    {this.state.colors}
                </Swiper>
            </>
        );
    }
}